exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.theme--light.v-expansion-panel .v-expansion-panel__container[data-v-1e764b04] {\n  border-top: 1px solid rgba(0,0,0,0);\n}\n.listContacts[data-v-1e764b04] {\n  margin-left: 46px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1e764b04","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/trafic/Contact.vue
// module id = 2r5v
// module chunks = 1